<script>
import { defineComponent, inject } from 'vue-demi'
import { PROVIDE_KEYS } from './consts'

const HKLFormItemContent = defineComponent({
  setup () {
    const canEdit = inject(PROVIDE_KEYS.CAN_EDIT, true)
    return { canEdit }
  },
  render () {
    const slot = this.$scopedSlots.default()
    if (!Array.isArray(slot)) return slot
    let slots = slot
    if (slots.length === 1) {
      return slots[0]
    }
    if (slots.length >= 2) {
      slots = slots.filter((s) => !(s.tag === undefined && s.data === undefined && (typeof s.text === 'string' && s.text.trim().length === 0)))
    }
    return this.canEdit ? slots[0] : slots[1]
  },
})

export default HKLFormItemContent
</script>
